import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import { MonitoringState } from './types';
import { Module } from 'vuex';
import { RootState } from '../types';

export const monitoring: Module<MonitoringState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
